var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgBack(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 17,
    height: 19,
    viewBox: "0 0 17 19",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M6.91105 1.37278L0.696833 7.58518C0.365181 7.95637 0.188107 8.44037 0.201923 8.93794C0.21574 9.43551 0.4194 9.90894 0.77114 10.2611C1.12288 10.6134 1.59604 10.8176 2.09359 10.8321C2.59115 10.8466 3.07539 10.6701 3.447 10.339L6.38972 7.40172L6.38972 16.1118C6.38972 16.6283 6.59488 17.1236 6.96007 17.4887C7.32525 17.8539 7.82055 18.0591 8.337 18.0591C8.85345 18.0591 9.34875 17.8539 9.71394 17.4887C10.0791 17.1236 10.2843 16.6283 10.2843 16.1118L10.2843 7.37265L13.2561 10.339C13.4328 10.5368 13.6481 10.6965 13.8887 10.8082C14.1293 10.9199 14.3902 10.9813 14.6554 10.9887C14.9206 10.996 15.1845 10.9492 15.4309 10.851C15.6774 10.7528 15.9012 10.6054 16.0886 10.4176C16.2761 10.2299 16.4233 10.0059 16.5211 9.75936C16.619 9.51279 16.6655 9.24883 16.6578 8.98366C16.6501 8.71849 16.5883 8.45768 16.4763 8.21721C16.3642 7.97674 16.2043 7.76168 16.0062 7.58518L9.79201 1.37278C9.61144 1.19163 9.39682 1.04798 9.16052 0.950094C8.92421 0.852205 8.67089 0.802011 8.41511 0.8024C8.39331 0.8024 8.37151 0.8024 8.35153 0.8024C8.0851 0.793192 7.81963 0.8391 7.57176 0.937246C7.32389 1.03539 7.09896 1.18367 6.91105 1.37278Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBack);
export default __webpack_public_path__ + "static/media/back.276aaf56f1c18e64394e08d7a46afc82.svg";
export { ForwardRef as ReactComponent };